module.exports = __webpack_public_path__ + "img/logo_sv.cf8502ee.png";